var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencilFilled = function SvgPencilFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62693 16.4197C5.57067 16.476 5.53906 16.5523 5.53906 16.6318V19.1238C5.53906 19.2895 5.67338 19.4238 5.83906 19.4238H8.33106C8.41062 19.4238 8.48693 19.3922 8.54319 19.336L16.8442 11.0349C16.9614 10.9178 16.9614 10.7278 16.8442 10.6107L14.3522 8.11867C14.2351 8.00151 14.0451 8.00151 13.928 8.11867L5.62693 16.4197ZM19.3116 8.56756C19.6149 8.26427 19.6149 7.77433 19.3116 7.47104L17.4918 5.6513C17.1886 5.34801 16.6986 5.34801 16.3953 5.6513L15.1843 6.8623C15.0672 6.97946 15.0672 7.16941 15.1843 7.28656L17.6763 9.77856C17.7935 9.89572 17.9834 9.89572 18.1006 9.77856L19.3116 8.56756Z",
    fill: "#1967D2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencilFilled);
export default ForwardRef;